/**
 * Constants related to Album Folder Photos Feature.
 */

/**
 * Upload modes available per album folder.
 */
const UPLOAD_MODE = {
  PUBLISH: 'PUBLISH',
  REVIEW: 'REVIEW',
};

export { UPLOAD_MODE };
